import { render, staticRenderFns } from "./SideNavigation.vue?vue&type=template&id=5445bca6&"
import script from "./SideNavigation.vue?vue&type=script&lang=ts&"
export * from "./SideNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5445bca6')) {
      api.createRecord('5445bca6', component.options)
    } else {
      api.reload('5445bca6', component.options)
    }
    module.hot.accept("./SideNavigation.vue?vue&type=template&id=5445bca6&", function () {
      api.rerender('5445bca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/navigation/side/SideNavigation.vue"
export default component.exports